import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowCircularBottomLeftS } from '@lichtblick/photon/icons/arrows/arrow-circular-bottom-left-s';
import { CrossCircleS } from '@lichtblick/photon/icons/symbols/cross-circle-s';
export const STATIC_FOOTER_SECONDARY_LINKS = [
    {
        href: '/vertrag-widerrufen/',
        icon: /*#__PURE__*/ _jsx(ArrowCircularBottomLeftS, {}),
        label: 'Vertrag widerrufen'
    },
    {
        href: '/vertrag-kuendigen/',
        icon: /*#__PURE__*/ _jsx(CrossCircleS, {}),
        label: 'Vertrag hier kündigen'
    },
    {
        href: '/impressum/',
        label: 'Impressum'
    },
    {
        href: '/datenschutz/',
        label: 'Datenschutz'
    },
    {
        href: '/hinweisgebersystem/',
        label: 'Hinweis geben'
    },
    {
        href: '/barrierefreiheit/',
        label: 'Barrierefreiheit'
    },
    {
        href: '#uc-central-modal-show',
        label: 'Cookie-Zustimmung'
    },
    {
        href: '/kontakt/',
        label: 'Kontakt'
    },
    {
        href: '/rechtliche-hinweise/',
        label: 'Rechtliche Hinweise'
    },
    {
        href: '/veroeffentlichungen/',
        label: 'Veröffentlichungen'
    },
    {
        href: '/marktpartner/',
        label: 'Marktpartner'
    }
];
export const getStaticFooterHref = (href, websiteBaseUrl)=>{
    if (!href.startsWith('/') || !websiteBaseUrl) {
        return href;
    }
    return new URL(href, websiteBaseUrl).toString();
};

//# sourceMappingURL=Static.js.map